import React, { useState } from 'react';
import { Menu, X, Rocket } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const SpaceJetNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Advertisers', href: '/advertisers', type: 'route' },
    { name: 'Publishers', href: '/affiliates', type: 'route' },
    { name: 'About', href: '#about', type: 'anchor' },
    { name: 'Resources', href: '#resources', type: 'anchor' },
    { name: 'Contact', href: '/contact', type: 'route' },
  ];

  const isActive = (item) => {
    if (item.type === 'anchor') return false;
    return location.pathname === item.href || location.pathname.startsWith(`${item.href}/`);
  };

  const navLinkClass = (active) => [
    'text-[11px] font-semibold uppercase tracking-[0.26em] transition-colors duration-200',
    active ? 'text-slate-50' : 'text-slate-300 hover:text-slate-50',
  ].join(' ');

  return (
    <nav className="sticky top-0 z-50 border-b border-white/[0.06] bg-[#050b17]/76 backdrop-blur-2xl">
      <div className="mx-auto max-w-[1800px] px-6 py-5 lg:px-20">
        <div className="flex items-center justify-between gap-6">
          <Link to="/" className="group flex items-center gap-4">
            <div className="relative flex h-11 w-11 items-center justify-center rounded-full border border-slate-500/20 bg-[linear-gradient(180deg,rgba(30,41,59,0.72),rgba(2,6,23,0.84))] shadow-[0_0_30px_rgba(96,165,250,0.08)]">
              <Rocket className="h-5 w-5 text-slate-100" />
              <span className="absolute right-0 top-0 h-2.5 w-2.5 rounded-full bg-red-400 shadow-[0_0_12px_rgba(194,65,65,0.48)]" />
            </div>
            <div className="leading-none">
              <div className="text-[12px] font-semibold uppercase tracking-[0.34em] text-slate-50 sm:text-sm">
                SPACEJET NETWORK
              </div>
            </div>
          </Link>

          <div className="hidden flex-1 items-center justify-center lg:flex">
            <div className="flex items-center gap-10">
              {navigation.map((item) =>
                item.type === 'route' ? (
                  <Link key={item.name} to={item.href} className={navLinkClass(isActive(item))}>
                    {item.name}
                  </Link>
                ) : (
                  <a key={item.name} href={item.href} className={navLinkClass(false)}>
                    {item.name}
                  </a>
                ),
              )}
            </div>
          </div>

          <div className="hidden items-center gap-5 lg:flex">
            <a href="https://network.linktrust.com" target="_blank" rel="noopener noreferrer" className="rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.26em] text-slate-200 transition-colors hover:border-white/15 hover:bg-white/[0.05] hover:text-white">
              Log In
            </a>
            <Link
              to="/signup"
              className="spacejet-btn-primary inline-flex items-center gap-2 rounded-md px-5 py-3 text-[11px] font-semibold uppercase tracking-[0.24em] shadow-[0_12px_24px_-18px_rgba(194,65,65,0.6)] transition-transform duration-200 hover:-translate-y-0.5"
            >
              Sign Up
            </Link>
          </div>

          <button
            onClick={() => setIsOpen((v) => !v)}
            className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/10 text-slate-100 transition-colors hover:bg-white/5 lg:hidden"
            aria-label="Toggle navigation"
          >
            {isOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="border-t border-white/[0.06] bg-[#050b17]/92 backdrop-blur-2xl lg:hidden">
          <div className="mx-auto max-w-[1800px] px-6 py-5 lg:px-20">
            <div className="grid gap-3">
              {navigation.map((item) =>
                item.type === 'route' ? (
                  <Link
                    key={item.name}
                    to={item.href}
                    onClick={() => setIsOpen(false)}
                    className="rounded-2xl border border-white/[0.08] bg-white/[0.03] px-4 py-3 text-[11px] font-semibold uppercase tracking-[0.26em] text-slate-100"
                  >
                    {item.name}
                  </Link>
                ) : (
                  <a
                    key={item.name}
                    href={item.href}
                    onClick={() => setIsOpen(false)}
                    className="rounded-2xl border border-white/[0.08] bg-white/[0.03] px-4 py-3 text-[11px] font-semibold uppercase tracking-[0.26em] text-slate-100"
                  >
                    {item.name}
                  </a>
                ),
              )}
              <a
                href="https://network.linktrust.com"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setIsOpen(false)}
                className="rounded-2xl border border-white/[0.08] bg-white/[0.03] px-4 py-3 text-[11px] font-semibold uppercase tracking-[0.26em] text-slate-100"
              >
                Log In
              </a>
              <Link
                to="/signup"
                onClick={() => setIsOpen(false)}
                className="spacejet-btn-primary inline-flex items-center justify-center gap-2 rounded-md px-4 py-3 text-[11px] font-semibold uppercase tracking-[0.26em]"
              >
                Sign Up
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default SpaceJetNavbar;
